import styled from "styled-components";
import { colors } from "@/theme";

export const DealerExpandedInfoContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr 1fr;
  column-gap: 16px;
  padding: 16px 0;
`;

export const CoopInfoContainer = styled.div`
  border: ${`1px solid ${colors.black}`};
  border-radius: 12px;
  padding: 16px;
  background-color: rgba(51, 122, 206, 0.1);
`;
